import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthDataHolderService {
  authHolder: any;

  constructor() {}
}
